export default {"src":"/_next/static/media/graph.384f49d2.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};